import { t } from "i18next";
import dayjs from "dayjs";
import type { Person, UpdatePersonRequest } from "@/services/api/entities/person/types";
import type { ActivitiesTabFormValues } from "../schemas";

type GetAboutDate = (data: { dateFrom: string; dateTo?: string | null }) => string;

export const transformActivitiesFormDataToUpdatePerson = ({
  data,
  defaultValuesPerson,
}: {
  data: ActivitiesTabFormValues;
  defaultValuesPerson: Person;
}): UpdatePersonRequest => {
  return {
    ...defaultValuesPerson,
    group: null,
    careers: data.careers.map((item) => ({
      ...(item.id && { id: item.id }),
      personId: item.personId ?? "",
      about: item.about ?? "",
      careerEnd: item.careerEnd ?? "",
      industry: { name: item.industry?.name ?? "" },
      careerStart: item.careerStart ?? "",
      company: item.company ?? "",
      jobTitle: item.jobTitle ?? "",
    })),
    competences: data.competences.map((item) => ({
      about: item.about ?? "",
      competenceType: { name: item.competenceType?.name ?? "" },
      ...(item.id && { id: item.id }),
    })),
    educations: data.educations.map((item) => ({
      about: item.additional ?? "",
      educationEnd: item.educationEnd ?? "",
      educationStart: item.educationStart ?? "",
      ...(item.id && { id: item.id }),
      personId: item.personId ?? "",
      major: item.major ?? "",
      school: item.place ?? "",
    })),
    hobbies: data.hobbies.map((item) => ({
      about: item.about ?? "",
      hobbyType: { name: item.hobbyType?.name ?? "" },
      ...(item.id && { id: item.id }),
    })),
    professionalActivities: data.professionalActivities.map((item) => ({
      activity: item.activity ?? "",
      ...(item.id && { id: item.id }),
      personId: item.personId ?? "",
      industry: { name: item.industry?.name ?? "" },
      role: item.role ?? "",
    })),
  };
};

export const getDefaultActivitiesTabFormValues = (
  currentPerson: Person,
): ActivitiesTabFormValues => {
  return {
    careers:
      currentPerson?.careers.map((item) => ({
        ...item,
        careerStart: item.careerStart,
        careerEnd: item.careerEnd,
      })) ?? [],
    competences: currentPerson?.competences ?? [],
    educations:
      currentPerson?.educations.map((item) => ({
        ...item,
        place: item.school,
        additional: item.about,
      })) ?? [],
    hobbies: currentPerson?.hobbies ?? [],
    professionalActivities: currentPerson?.professionalActivities ?? [],
  };
};

export const getAboutDate: GetAboutDate = ({ dateFrom, dateTo }) => {
  if (!dateTo) return `${dayjs(dateFrom).year()}-${t("common.present")}`;
  return `${dayjs(dateFrom).year()}-${dayjs(dateTo).year()}`;
};
